import { render, staticRenderFns } from "./DepartmentHero.vue?vue&type=template&id=dd2b52d2&scoped=true"
import script from "./DepartmentHero.vue?vue&type=script&lang=js"
export * from "./DepartmentHero.vue?vue&type=script&lang=js"
import style0 from "./DepartmentHero.vue?vue&type=style&index=0&id=dd2b52d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2b52d2",
  null
  
)

export default component.exports